import type { MarketplaceKey } from "./registry";

/** Values accepted by `POST/PATCH /goods` (`marketplace` field). */
export type ApiMarketplaceKey = "wb" | "ozon" | "kaspi" | "olx" | "flip" | "other";

/** UI/store key for universal content → backend enum. */
export function marketplaceKeyToApi(marketplace: MarketplaceKey | string): ApiMarketplaceKey {
  if (marketplace === "generic") return "other";
  return marketplace as ApiMarketplaceKey;
}

/** Backend enum → UI/store key. */
export function marketplaceKeyFromApi(marketplace: string): MarketplaceKey {
  if (marketplace === "other") return "generic";
  return marketplace as MarketplaceKey;
}
